import posthog from 'posthog-js'
import config from '../config'

if (config.posthogApiKey) {
  posthog.init(config.posthogApiKey, {
    api_host: 'https://eu.i.posthog.com',
    // No cookies: identity is established via posthog.identify(user.sub) on every
    // session load, so cross-session stitching doesn't require browser persistence.
    persistence: 'memory',
    // Disable automatic captures and replace them with explicit calls:
    // - autocapture would record every button click, potentially capturing
    //   user-generated content (team names, player names) as PII.
    // - capture_pageview/pageleave fire on window.location changes and miss
    //   SPA navigations; AnalyticsPageTracker handles pageviews via useLocation().
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: false,
    // Disable automatic $web_vitals capture: we only want our explicit events.
    capture_performance: false,
  })
}

export { posthog }
